import script from "./FeedBackPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBackPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedBackPage.vue?vue&type=style&index=0&id=8aa504ce&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aa504ce"]])

export default __exports__